import React from 'react';
import { Header } from '../Header';
import { Footer } from '../Footer';
import styles from '../../pages/legal/Legal.module.css';

interface LegalLayoutProps {
  label: string;
  title: string;
  subtitle?: string;
  lastUpdated: string;
  children: React.ReactNode;
}

export const LegalLayout: React.FC<LegalLayoutProps> = ({ 
  label, 
  title, 
  subtitle, 
  lastUpdated, 
  children 
}) => {
  return (
    <div className="app">
      <Header />
      <main className={styles.legalPage}>
        <div className={styles.container}>
          <header className={styles.header}>
            <div className={styles.label}>{label}</div>
            <h1>{title}</h1>
            {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
            <p className={styles.updated}>Last Updated: {lastUpdated}</p>
          </header>
          
          <div className={styles.content}>
            {children}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};
